import React from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";
import _ from "lodash";

const BarScatterChart = (props) => {
    const {
        barWidthCustom = "7%",
  chartData = [],
  chartStyle,
  footerBar = false,
  isScrollEndLimit = 50,
  isScrollStartLimit = 0,
  labelConfig,
  maxScrollLimit = 30,
  minScrollLimit = 10,
  otherYaxisProperty = {},
  otherZoomProperty = {},
  otherZoomPropertyInsider = {},
  otherZoomPropertySlider = {},
  scrollBarLeftAlign = 0,
  scrollEnabled = false,
  ScatterData = [],
  spaceBottom = "1%",
  spaceLeft = "2%",
  spaceRight = "5%",
  spaceTop = "8%",
  symbol = "",
  toolTipConfig,
  events,
  onChartClick,
    } = props;

    let colorPalette = [];

    const getColor = (index) => {
        return colorPalette[index % colorPalette.length];
    };   

    const option = {
        tooltip: toolTipConfig
            ? { ...toolTipConfig }
            : {
                trigger: "item",
                formatter: function (params) {
                    return params.name + "<br/>" + params.seriesName + ":" + params.value;
                }
            },
        legend: {
            show: false,
            data: ["Bar", "Scatter"],
        },
        xAxis: {
            show: false,
            type: "value",
            axisTick: { show: false, },
            axisLine: { show: false, },
        },
        yAxis: {
            show: false,
            inverse: true,
            type: "category",
            splitLine: {
                show: false
            },
            axisTick: { show: false, },
            axisLine: { show: false, },
            ...otherYaxisProperty
        },
        grid: {
            top: spaceTop,
            left: spaceLeft,
            right: spaceRight,
            bottom: spaceBottom ,
            containLabel: true,
        },
        ...(scrollEnabled && {
            dataZoom: [
                {
                    type: "slider",
                    start: isScrollStartLimit ? isScrollStartLimit : 0,
                    end: isScrollEndLimit,
                    width: 10,
                    left: scrollBarLeftAlign ? scrollBarLeftAlign : 0,
                    orient: "vertical",
                    yAxisIndex: 0,
                    showDetail: false,
                    minSpan: minScrollLimit ,
                    maxSpan: maxScrollLimit,
                    ...otherZoomProperty,
                    ...otherZoomPropertySlider
                },
                {
                    type: "inside",
                    start: isScrollStartLimit ? isScrollStartLimit : 0,
                    end: isScrollEndLimit ,
                    yAxisIndex: 0,
                    minSpan: minScrollLimit,
                    maxSpan: maxScrollLimit ,
                    ...otherZoomProperty,
                    ...otherZoomPropertyInsider
                }
            ]
        }),
        series: [
            ...chartData.map((seriesData) => ({
                name: "Bar",
                type: "bar",
                data: seriesData.data || [],
                barWidth: barWidthCustom || "7%",
                barCategoryGap: "30%",
                label: labelConfig ? { ...labelConfig } : {
                    show: true,
                    position: "start",
                    offset: [4, -15],
                    formatter: (params) => {
                        const labelText = seriesData.Label[params.dataIndex];
                        return labelText?.length > 20 ? labelText.slice(0, 20) + '...' : labelText;
                    },
                },
                itemStyle: {
                    color: (params) => seriesData.color ? seriesData.color[params.dataIndex] : getColor(params.dataIndex)
                },
            })),
            ...(footerBar
                ? chartData.map((seriesData) => ({
                    name: "Footer Bar",
                    type: "bar",
                    data: seriesData.footerUnData || [],

                    barWidth: "1%",
                    barCategoryGap: "30%",
                    label: labelConfig
                        ? { ...labelConfig }
                        : {
                            show: true,
                            position: "start",
                            offset: [0, 5],
                            formatter: (params) => {
                                const labelText = seriesData.Label[params.dataIndex];

                                return labelText && seriesData?.footerData[labelText]
                                    ? seriesData.footerData[labelText].map(i =>
                                        Object.entries(i).map(([key, value]) => ` ${key}: ${value}`).join(", ")
                                    )
                                    : "";
                            },
                        },
                    itemStyle: {
                        color: 'transparent',
                    },
                }))
                : []),
            ...ScatterData.map((seriesData, scatterIndex) => ({
                name: "Scatter",
                type: "scatter",
                data: seriesData.data || [],
                yAxisIndex: 0,
                symbolSize: 35,
                symbol: symbol ? symbol : "",
                label: {
                    show: true,
                    color: "white",
                    fontSize: 12,
                    formatter: (params) => {
                        const label = seriesData.labelData?.[params.dataIndex];
                        return label !== undefined ? label : "";
                    },
                },
                itemStyle: {
                    color: (params) => {
                        return getColor(params.dataIndex);
                    },
                    opacity: 1,
                }
            }))


        ],
    };
const handleChartClick = (params) => {
  onChartClick(params, props);
};

    const onEvents = {
        'click': handleChartClick,
    };
    return (
        <div>
            <ReactECharts
                option={option}
                style={chartStyle}
                onEvents={events ? onEvents : ""}
            />
        </div>
    );
};

function areEqual(prevProps, nextProps) {
  return (
    _.isEqual(prevProps.data, nextProps.data) &&
    _.isEqual(prevProps.spaceLeft, nextProps.spaceLeft) &&
    _.isEqual(prevProps.spaceRight, nextProps.spaceRight) &&
    _.isEqual(prevProps.spaceTop, nextProps.spaceTop) &&
    _.isEqual(prevProps.spaceBottom, nextProps.spaceBottom) &&
    _.isEqual(prevProps.chartData, nextProps.chartData) &&
    _.isEqual(prevProps.ScatterData, nextProps.ScatterData) &&
    _.isEqual(prevProps.symbol, nextProps.symbol) &&
    _.isEqual(prevProps.toolTipConfig, nextProps.toolTipConfig) &&
    _.isEqual(prevProps.labelConfig, nextProps.labelConfig) &&
    _.isEqual(prevProps.footerBar, nextProps.footerBar) &&
    _.isEqual(prevProps.scrollEnabled, nextProps.scrollEnabled) &&
    _.isEqual(prevProps.isScrollStartLimit, nextProps.isScrollStartLimit) &&
    _.isEqual(prevProps.isScrollEndLimit, nextProps.isScrollEndLimit) &&
    _.isEqual(prevProps.scrollBarLeftAlign, nextProps.scrollBarLeftAlign) &&
    _.isEqual(prevProps.barWidthCustom, nextProps.barWidthCustom) &&
    _.isEqual(prevProps.minScrollLimit, nextProps.minScrollLimit) &&
    _.isEqual(prevProps.maxScrollLimit, nextProps.maxScrollLimit) &&
    _.isEqual(prevProps.chartStyle, nextProps.chartStyle) &&
    _.isEqual(prevProps.otherZoomProperty, nextProps.otherZoomProperty) &&
    _.isEqual(prevProps.otherZoomPropertyInsider, nextProps.otherZoomPropertyInsider) &&
    _.isEqual(prevProps.otherZoomPropertySlider, nextProps.otherZoomPropertySlider) &&
    _.isEqual(prevProps.otherYaxisProperty, nextProps.otherYaxisProperty)
  );
}
BarScatterChart.propTypes = {
    barWidthCustom: PropTypes.string,
    chartData: PropTypes.array,
    chartStyle: PropTypes.object,
    footerBar: PropTypes.bool,
    isScrollEndLimit: PropTypes.number,
    isScrollStartLimit: PropTypes.number,
    labelConfig: PropTypes.object,
    maxScrollLimit: PropTypes.number,
    minScrollLimit: PropTypes.number,
    otherYaxisProperty: PropTypes.object,
    otherZoomProperty: PropTypes.object,
    otherZoomPropertyInsider: PropTypes.object,
    otherZoomPropertySlider: PropTypes.object,
    scrollBarLeftAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scrollEnabled: PropTypes.bool,
    ScatterData: PropTypes.array,
    spaceBottom: PropTypes.string,
    spaceLeft: PropTypes.string,
    spaceRight: PropTypes.string,
    spaceTop: PropTypes.string,
    symbol: PropTypes.string,
    toolTipConfig: PropTypes.object,
    events: PropTypes.objectOf(PropTypes.func),
    onChartClick: PropTypes.func,
  };
export default React.memo(BarScatterChart, areEqual);


